import { DevBreadcrumbsComponentModule } from '../../components/dev-breadcrumbs/dev-breadcrumbs.module';
import { FlxCommonsModule } from '@questrade/flx-commons';
import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { SandboxPage } from './sandbox';
import { DevJumbotronComponentModule } from '../../components/dev-jumbotron/dev-jumbotron.module';

@NgModule({
    declarations: [
        SandboxPage,
    ],
    imports: [
        DevBreadcrumbsComponentModule,
        DevJumbotronComponentModule,
        FlxCommonsModule,
        IonicPageModule.forChild(SandboxPage),
    ],
    exports: [
        SandboxPage
    ]
})
export class SandboxPageModule { }



// WEBPACK FOOTER //
// ./src/pages/sandbox/sandbox.module.ts